// Connection auth button
// Insert in HTML <div id="authButton"></div>

export const authBtnId3 = (cb) => {
  let userId = 0;

  (() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://id3.expertus.com.ua/js/loader.js';
    script.onload = onLoadLoaderScript;
    document.getElementsByTagName('head')[0].appendChild(script);
  })();

  function onLoadLoaderScript() {
    window.AuthButton.init({ appId: 2564, typeBtn: 2 /* 1 or 2 or 3 */, handleToken, handleLogout });
  }

  function handleToken(token, userId) {
    userId = userId;
    console.log({ token, userId });
    localStorage.setItem('token', token);
    cb(token);
  }

  function handleLogout() {
    console.log('logout');
    localStorage.removeItem('token');
  }

  // You can call the function when the user is authorized
  function handleActionMarketing() {
    if (typeof window.AuthButton !== 'undefined' && userId > 0) {
      window.AuthButton.saveAction([
        224 /*action id*/,
        'uaorganictraffic' /* name action*/,
        window.location.href /*source*/,
        '' /*category1*/,
        '' /*category2*/,
        '' /*actionvalue*/,
      ]);
    }
  }
}
